import React from 'react';

/** Small typography primitives so post bodies read like markdown but stay typed JSX. */

export const H2: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h2 className="text-2xl font-bold text-white mt-12 mb-4">{children}</h2>
);

export const H3: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h3 className="text-lg font-semibold text-zinc-100 mt-8 mb-3">{children}</h3>
);

export const P: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="text-zinc-400 leading-relaxed mb-4">{children}</p>
);

export const Strong: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <strong className="text-zinc-200 font-semibold">{children}</strong>
);

export const UL: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ul className="list-disc pl-6 space-y-2 text-zinc-400 leading-relaxed mb-4 marker:text-yellow-400">
    {children}
  </ul>
);

export const OL: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ol className="list-decimal pl-6 space-y-2 text-zinc-400 leading-relaxed mb-4 marker:text-yellow-400">
    {children}
  </ol>
);

export const Callout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <aside className="border-l-4 border-yellow-400 bg-zinc-900/60 rounded-r-lg px-5 py-4 mb-6 text-zinc-300 leading-relaxed">
    {children}
  </aside>
);

export const Table: React.FC<{ head: string[]; rows: string[][] }> = ({ head, rows }) => (
  <div className="overflow-x-auto mb-6">
    <table className="w-full text-left text-sm border border-zinc-800 rounded-lg">
      <thead className="bg-zinc-900 text-zinc-300">
        <tr>
          {head.map((h, i) => (
            <th key={h} className={`px-4 py-2 font-semibold ${i === head.length - 1 ? 'text-right' : ''}`}>
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="text-zinc-400">
        {rows.map((row) => (
          <tr key={row[0]} className="border-t border-zinc-800">
            {row.map((cell, i) => (
              <td key={i} className={`px-4 py-2 ${i === row.length - 1 ? 'text-right' : ''}`}>
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
